module.exports = __webpack_public_path__ + "media/src/images/partners/tusur-e3b85adb27f4d1b3ad60ff43bddb9600.jpg";